import { useContext, useMemo, useCallback } from 'react';

import { PAGES } from 'consts/pages';

import PqlState from './PqlState';

const EMPTY = [];

const useQueryHighlights = () => {
  const { state } = useContext(PqlState);
  const attributes = state[PAGES.investigator]?.queryAttributes || EMPTY;

  const highlightMap = useMemo(() => {
    const map = new Map();
    attributes.forEach((attr, i) => map.set(attr, i));
    return map;
  }, [attributes]);

  const getHighlightIndex = useCallback(
    (dotPath) => {
      if (!dotPath || highlightMap.size === 0) return -1;
      if (highlightMap.has(dotPath)) return highlightMap.get(dotPath);
      if (highlightMap.has(`data.${dotPath}`)) return highlightMap.get(`data.${dotPath}`);
      return -1;
    },
    [highlightMap],
  );

  const getIsHighlighted = useCallback((dotPath) => getHighlightIndex(dotPath) !== -1, [getHighlightIndex]);

  return {
    getIsHighlighted,
    getHighlightIndex,
    hasHighlights: highlightMap.size > 0,
  };
};

export default useQueryHighlights;
